import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertNumberToPersian'
})
export class ConvertNumberToPersianPipe implements PipeTransform {

  transform(value: any, args?: any): any {
      let persian = {0: '۰', 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹'};
      let str = (value + '').split('');
      let count = str.length;
      let num;
      for (let i = 0; i <= count; i++) {
          num = str[i];
          if (persian[num]) {
              str[i] = persian[num];
          }
      }
      return str.join('');
  }


}
